<div class="auth-page">
	@for (card of infoCards; track card.title) {
		<div class="info-card">
			<div [innerHTML]="card.icon | safeHtml"></div>
			<h3>{{ card.title }}</h3>
			<p>{{ card.description }}</p>
		</div>
	}
</div>
